import React from 'react';
import { ChevronRightIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { OFFER_ANCHOR, PACK_IMAGE, PRODUCT, ROUTE } from '../data/content';
export function SystemSection() {
  return <section aria-labelledby="sistema" className="border-y-4 border-solar bg-navy" data-id="element-187" data-mp="3bh25tygta4cb">
      <div className="mx-auto max-w-page px-3 py-5 sm:px-6 sm:py-7" data-id="element-188" data-mp="36lwj4xfl4ln6">
        <Reveal className="text-center" data-id="element-189" data-mp="31lim0afiuw3x">
          <p className="text-[0.66rem] font-black uppercase tracking-[0.24em] text-solar sm:text-xs" data-id="element-190" data-mp="31mjz0kg3lsoa">
            ☀️ El sistema completo 6 en 1
          </p>
          <h2 id="sistema" className="mt-0.5 font-display text-xl uppercase leading-[1.04] text-white sm:text-3xl" data-id="element-191" data-mp="2st6xiu3yxiql">
            {PRODUCT}
          </h2>
        </Reveal>

        <Reveal delay={0.04} className="mx-auto mt-2 flex max-w-4xl flex-wrap items-center justify-center gap-1" data-id="element-192" data-mp="2itpr2agw70tk">
          {ROUTE.map((step, i) => <React.Fragment key={step} data-id="element-193" data-mp="13y6lb1npzu6m" data-mpi={i}>
              <span className="rounded-md bg-azure px-2.5 py-1 text-[0.66rem] font-black uppercase tracking-wide text-white sm:px-3 sm:text-[0.76rem]" data-id="element-194" data-mp="13x4zc2561na4">
                {step}
              </span>
              {i < ROUTE.length - 1 && <ChevronRightIcon size={13} aria-hidden="true" className="text-solar" strokeWidth={3} data-id="element-195" data-mp="yzlm95k7fgjr" />}
            </React.Fragment>)}
        </Reveal>

        <Reveal delay={0.08} className="mt-3" data-id="element-196" data-mp="1rmg3zupn01tj">
          <a href={OFFER_ANCHOR} className="block" data-id="element-197" data-mp="1cqhznp5k7r68">
            <img src={PACK_IMAGE} alt={`Contenido incluido en ${PRODUCT}`} className="mx-auto w-full max-w-lg rounded-lg border-2 border-solar" data-id="element-198" data-mp="1ctw1mwab9yd5" />
          </a>
        </Reveal>

        <Reveal delay={0.1} className="mt-3 flex justify-center" data-id="element-199" data-mp="6bz7r29furi4">
          <CtaButton size="lg" data-id="element-200" data-mp="6939fctoi0t5">
            🔥 ¡SÍ! QUIERO EL SISTEMA COMPLETO POR $19.990
          </CtaButton>
        </Reveal>
      </div>
    </section>;
}